import { type IGenBlogArticle_Content, type IGenNewsArticle_Content } from "@/services/graphql/__generated/sdk";
import { type Nullable } from "@/utils/types";

import { RichTextRenderer } from "@caisy/rich-text-react-renderer";
import React, { type FunctionComponent } from "react";

import { DocumentLink } from "./DocumentLink";

interface IDocumentLinkProps
{
  readonly connections: any;
  readonly node: any;
}

const RenderDocumentLink: FunctionComponent<IDocumentLinkProps> = ({ connections, node }) =>
{
  if(!node || !connections)
  {
    return null;
  }

  return (
    <DocumentLink
      node={node}
      connections={connections}
    />
  );
};

interface IProps
{
  readonly content?: Nullable<IGenNewsArticle_Content | IGenBlogArticle_Content>;
}

// eslint-disable-next-line react/no-multi-comp
const FullText: FunctionComponent<IProps> = ({ content }) =>
{
  if(!content?.json)
  {
    return null;
  }

  return (
    <article>
      {content.json && (
        <RichTextRenderer
          node={content.json}
          overwrites={{
            // eslint-disable-next-line react/no-unstable-nested-components,react/prop-types
            documentLink: props => <RenderDocumentLink node={props.node} connections={content.connections}/>,
          }}
        />
      )}
    </article>
  );
};

export default FullText;
